import { render, staticRenderFns } from "./AutoInfracaoRs.vue?vue&type=template&id=cfbb56f0&lang=pug"
import script from "./AutoInfracaoRs.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports